module.exports = __webpack_public_path__ + "assets/img/solar-panels-4-small.31e2caa7.jpg";